export default __webpack_public_path__ + "static/img_11-29f84fafd1c766923eeed9c407887874.png";